import { useContext } from "react";
import Header from "./Header/Header";
import Content from "./Content/Content";
import { Box, Stack } from "@mui/material";
import FooterLinks from "src/components/Footer/FooterLinks";
import { ThemeValues } from "src/components/ThemeUsage/theme";
import { ThemeContext } from "src/components/ThemeUsage/ThemeUsage";
import { useMatomoExperiment } from "src/useMa";
import BoldSubtitle from "src/components/Displays/BoldSubtitle";
const VARIATIONS = ["original", "Variation1", "Variation2"];

const IntroductionLB = () => {
  const themeName = useContext(ThemeContext);
  const isUserSelectEnabled = themeName !== ThemeValues.lichtblick;
  const activeVariant = useMatomoExperiment("demo-test", VARIATIONS);

  const getText = () => {
    let text = "";

    switch (activeVariant) {
      case "original":
        text = "This is the original variant.";
        break;
      case "Variation1":
        text = "This is Variation 1.";
        break;
      case "Variation2":
        text = "This is Variation 2.";
        break;
      default:
        text = "Unknown variant.";
    }
    return text;
  };

  return (
    <Stack
      sx={(theme) => ({
        minHeight: "100vh",
        background: theme.palette.background.default,
        userSelect: isUserSelectEnabled ? undefined : "none",
      })}
    >
      <Stack
        alignItems="center"
        sx={(theme) => ({
          width: "100%",
          minHeight: "100vh",
          px: 4,
        })}
      >
        <BoldSubtitle text={getText()} />

        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{
            width: "fit-content",
            maxWidth: "1279px",
          }}
        >
          <Header />
          <Box
            sx={{
              height: "36px",
            }}
          />
          <Content />
        </Stack>
        <Box
          sx={{
            height: "36px",
          }}
        />
      </Stack>

      <FooterLinks isIntroductionPage={true} />
    </Stack>
  );
};

export default IntroductionLB;
